const descMenu = { 
  menuOverlay: document.getElementById("jsMenuOverlay") as HTMLElement,
  header: document.getElementById("header") as HTMLElement,
  menu: document.getElementById('jsMegaMenu') as HTMLElement,
  lvl1: document.querySelectorAll(".jsLvl1") as NodeListOf<HTMLElement>,
  lvl2: document.querySelectorAll(".jsLvl2") as NodeListOf<HTMLElement>,
  init() {
    this.setlvl1();
    this.setlvl2();    
    this.closeOverlay();
  },
  setlvl1() {
    this.lvl1.forEach((lvl) => {
      const level2 = lvl.nextElementSibling?.querySelector('.jsLvl2')
      if(level2) {
        level2.nextElementSibling?.classList.add("activeClass")
        level2.classList.add("activeClass")
      }
      lvl.addEventListener("click", (e) => {
        e.preventDefault();
        this.resetLevel1()
        lvl.nextElementSibling?.classList.add("activeClass")
        lvl.classList.add("activeClass")
        this.menuOverlay.classList.add("activeClass");
        // this.header.classList.add('activeClass')       
        document.documentElement.style.overflow = "hidden";
      });
    });
  },
  setlvl2() {
    this.lvl2.forEach((lvl) => {  
      lvl.addEventListener("click", (e) => {
        e.preventDefault();
        this.resetLevel2()
        lvl.nextElementSibling?.classList.add("activeClass")     
        lvl.classList.add("activeClass") 
      });
    });
  },

  resetLevel1(){
    this.lvl1.forEach(item=>{
      item.classList.remove("activeClass")
      item.nextElementSibling?.classList.remove("activeClass")
    })
  },
  resetLevel2(){
    this.lvl2.forEach(item=>{
      item.classList.remove("activeClass")
      item.nextElementSibling?.classList.remove("activeClass")
    })
  },
  closeOverlay() {
    window.addEventListener('click',(e)=>{
      const target = e.target as HTMLElement    
      if (target !== this.menu && !this.menu.contains(target)) {
        this.menuOverlay.classList.remove("activeClass");
        this.resetLevel1()
        document.documentElement.style.overflow = "auto";
        this.lvl1.forEach((lvl) => {
          lvl.classList.remove("activeClass");
        });
       }

    })
  
  },
};

export default descMenu;
